var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconFolderOpen = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("path", { d: "M24.5,22.6l0.2-0.4 c-0.8,1.9-1.3,2.5-2.5,2.5H4.8c-1.2,0-2.2-1-2.2-2.2V7.4c0-1.2,1-2.2,2.2-2.2h5.4l2.2,3.2h9.8c1.2,0,2.2,1,2.2,2.2V14" }),
                React.createElement("g", { transform: "translate(55.917 -9.25)" },
                    React.createElement("path", { d: "M-52.9,32.4l3.1-6.5 c0.6-1.3,1-2.2,2.2-2.2h16.1c2.7,0,3.1,0.9,2.8,1.9l-3.1,7.1" }))))));
});
export default IconFolderOpen;
//# sourceMappingURL=IconFolderOpen.js.map